// Kalman Claudsky: This component was originally built on react-dropdown-tree-select v2.3.3.
// That library's componentWillReceiveProps unconditionally called initNewProps() on every parent
// re-render, rebuilding its internal tree manager and wiping any active filter text or checked
// state. The second dropdown (inside the <Rnd> find-relation popup) was hit hardest: react-rnd's
// onDragStop fires from a native document mouseup listener outside React's batching, so its
// setState triggered a synchronous re-render *before* the click event on a filtered list item
// could fire -- the list position changed between mousedown and click, selecting the wrong item.
// Replacing the library with this custom combobox eliminates both problems entirely.

import React, { Component } from 'react';
import * as util from './newUtil.js';
import { withLocalize } from "react-localize-redux";
import translations from "./json/translations.json";
import { renderToStaticMarkup } from "react-dom/server";


class NameDropdown extends Component {
    constructor(props){
        super(props);
        this.state = {
            menuData: [],
            prevDropdownData: null,
            filterText: null,   // null = not actively filtering; string = user is typing
            isOpen: false,
        };
        this.props.initialize({
            languages: [
                { name: "עברית", code: "he" },
                { name: "English", code: "en" }
            ],
            translation: translations,
            options: { renderToStaticMarkup, renderInnerHtml: true, defaultLanguage: this.props.activeLanguage ? this.props.activeLanguage.code : 'en' }
        });
        this.blurTimer = null;
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleInputFocus  = this.handleInputFocus.bind(this);
        this.handleInputBlur   = this.handleInputBlur.bind(this);
        this.handleItemSelect  = this.handleItemSelect.bind(this);
    }

    // Kalman Claudsky: memoize menuData by reference-comparing dropdownData so we only
    // reprocess the full people list when the underlying data actually changes.
    static getDerivedStateFromProps(props, state) {
        if (props.dropdownData !== state.prevDropdownData) {
            const menuData = props.dropdownData
                ? props.dropdownData
                    .filter(person => isNaN(parseInt(person.name)))
                    .map(person => ({
                        label: util.removeNikud(person.name),
                        value: person,
                    }))
                : [];
            return { prevDropdownData: props.dropdownData, menuData };
        }
        return null;
    }

    componentWillUnmount() {
        clearTimeout(this.blurTimer);
    }

    handleInputChange(e) {
        this.setState({ filterText: e.target.value, isOpen: true });
    }

    handleInputFocus() {
        // Clear any pending blur so the list stays open when focus returns
        clearTimeout(this.blurTimer);
        this.setState({ isOpen: true });
    }

    handleInputBlur() {
        // Kalman Claudsky: intentional 200ms delay — onMouseDown on a list item must register
        // before we close the list. Without the delay, blur fires first and the list disappears
        // so the subsequent click lands on whatever is underneath instead of the intended item.
        this.blurTimer = setTimeout(() => {
            this.setState({ isOpen: false, filterText: null });
        }, 200);
    }

    handleItemSelect(item) {
        clearTimeout(this.blurTimer);
        this.setState({ isOpen: false, filterText: null });
        this.props.setFocusedNode(item.value);
    }

    render() {
        const chooseAName   = this.props.translate('chooseAName');
        const noMatchingName = this.props.translate('noMatchingName');

        const { filterText, isOpen, menuData } = this.state;
        const { nodeSelected, disabled } = this.props;

        // What the input shows: if actively filtering use filterText,
        // otherwise show the selected person's name (nikud stripped).
        const selectedLabel = nodeSelected && nodeSelected.fullName
            ? util.removeNikud(nodeSelected.fullName)
            : '';
        const inputValue = filterText !== null ? filterText : selectedLabel;

        // Filter the list when the user is typing
        const filteredData = filterText
            ? menuData.filter(item =>
                item.label.toLowerCase().includes(filterText.toLowerCase()))
            : menuData;

        const isRTL = this.props.activeLanguage && this.props.activeLanguage.code === 'he';

        return (
            <div className="yuchsin-name-dropdown-container" dir={isRTL ? 'rtl' : 'ltr'} style={{ position: 'relative' }}>
                <input
                    type="text"
                    className="yuchsin-name-filter-input"
                    value={inputValue}
                    placeholder={chooseAName}
                    disabled={disabled}
                    onChange={this.handleInputChange}
                    onFocus={this.handleInputFocus}
                    onBlur={this.handleInputBlur}
                    autoComplete="off"
                />
                {isOpen && !disabled && (
                    <ul className="yuchsin-name-dropdown-list">
                        {filteredData.length > 0
                            ? filteredData.map(item => (
                                <li
                                    key={item.value.index}
                                    onMouseDown={() => this.handleItemSelect(item)}
                                >
                                    {item.label}
                                </li>
                            ))
                            : <li className="yuchsin-name-dropdown-no-match">{noMatchingName}</li>
                        }
                    </ul>
                )}
            </div>
        );
    }
}

export default withLocalize(NameDropdown);
